import { ActionReducerMap, MetaReducer, ActionReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { routerReducer } from '@ngrx/router-store';
import { consultantReducer } from './consultant.reducer';
import { candidatesReducer } from './candidates.reducer';
import { candidateSearchReducer } from './candidate-search.reducer';
import { candidateReducer } from './candidate.reducer';
import { companiesReducer } from './companies.reducer';
import { jobtypesReducer } from './jobtypes.reducer';
import { selectedCandidatesReducer } from './selected-candidates.reducer';
import { testModelsReducer } from './test-models.reducer';
import { processesReducer } from './processes.reducer';
import { historyInvitationsReducer } from './history-invitations.reducer';
import { profilesReducer } from './profiles.reducer';
import { invitationsSearchReducer } from './invitations-search.reducer';
import { invitationsReducer } from './invitations.reducer';
import { questionReducer } from './question.reducer';
import { testReducer } from './test.reducer';

function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  // reducers a recuperar del localStorage
  // rehydrate permite recargar los datos del localstorage cuando recargamos la página y setearlo en los reducers de NgRx
  // deserialize modifica la forma en la que se parsean los datos del localStorage { count: { deserialize: count => Number(count) } }
  return localStorageSync({ keys: [
    'consultant',
    'candidates',
    'candidateSearch',
    'candidate',
    'companies',
    'jobtypes',
    'testModels',
    'processes',
    'historyInvitations',
    'profiles',
    'invitations',
    'invitationsSearch',
    'test'
  ], rehydrate: true })(reducer);
}

function reset(reducer: ActionReducer<any>): ActionReducer<any> {
  const initialState = reducer(undefined, { type: '' });
  return (state, action) => {
    // if reset action is fired, return initial state
    if (action.type === 'Reset') {
      return initialState;
    }
    // calculate next state based on action
    const nextState = reducer(state, action);
    // return nextState as normal when not reset action
    return nextState;
  };
}

export const reducers: ActionReducerMap<any> = {
  router: routerReducer,
  consultant: consultantReducer,
  candidates: candidatesReducer,
  candidateSearch: candidateSearchReducer,
  candidate: candidateReducer,
  companies: companiesReducer,
  jobtypes: jobtypesReducer,
  selectedCandidates: selectedCandidatesReducer,
  testModels: testModelsReducer,
  processes: processesReducer,
  historyInvitations: historyInvitationsReducer,
  profiles: profilesReducer,
  invitations: invitationsReducer,
  invitationsSearch: invitationsSearchReducer,
  questions: questionReducer,
  test: testReducer,
};

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer, reset];
